export async function disableStore(apiRoot, idToken, tenantId, id, setStores, setError) {
    try {
        const apiHeaders = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + idToken
        }
        const response = await fetch(`${apiRoot}/backoffice/tenants/${tenantId}/stores/${id}`, {
            method: 'DELETE',
            headers: apiHeaders,
        });

        if (!response.ok) {
            throw new Error('Failed to disable store');
        }

        setStores((prevStores) => prevStores.map((s) => (s.id === id ? { ...s, enabled: false } : s)));
    } catch (error) {
        console.error('Error disabling store:', error);
        setError('Failed to disable store.');
    }
}

export async function enableStore(apiRoot, idToken, tenantId, store, setStores, setError) {
    store.enabled = true;
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + idToken
    }
    try {
        const response = await fetch(`${apiRoot}/backoffice/tenants/${tenantId}/stores/${store.id}`, {
            method: 'PUT',
            headers: apiHeaders,
            body: JSON.stringify(store),
        });

        if (!response.ok) {
            throw new Error('Failed to enable store');
        }

        setStores((prevStores) => prevStores.map((s) => (s.id === store.id ? { ...s, enabled: true } : s)));
    } catch (error) {
        console.error('Error enabling store:', error);
        setError('Failed to enable store.');
    }
}

export async function toggleUmb(apiRoot, idToken, tenantId, store, setStores, setError) {
    const updatedStore = {
        ...store,
        isUmbEnabled: !store.isUmbEnabled
    };

    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + idToken
    };

    try {
        const response = await fetch(`${apiRoot}/backoffice/tenants/${tenantId}/stores/${store.id}`, {
            method: 'PUT',
            headers: apiHeaders,
            body: JSON.stringify(updatedStore),
        });

        if (!response.ok) {
            throw new Error('Failed to update UMB status on the server');
        }

        setStores((prevStores) =>
            prevStores.map((s) => (s.id === store.id ? updatedStore : s))
        );

    } catch (error) {
        console.error('Error toggling UMB:', error);
        setError('Failed to update UMB status.');
    }
}
